module.exports = __webpack_public_path__ + "57e98a58a552beb9e0da64d4fd983b2c.svg";